import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useMemo } from "react";

const pillars = [
  {
    k: "Une sélection exigeante",
    v: "Chaque instrument est choisi pour son élégance, sa qualité de fabrication et la richesse de sa vibration.",
  },
  {
    k: "Un ancrage réel dans l'Oise",
    v: "Compiègne, le studio SoundYoga, les bains sonores : un écosystème vivant où les instruments se découvrent.",
  },
  {
    k: "Un accueil humain",
    v: "Conseil personnalisé, orientation, contact direct — pour choisir avec plus de sérénité.",
  },
];

const studioPhotos = [
  "https://static.wixstatic.com/media/818fcb_6c6365d825404df099bf3cd3282520d1~mv2.jpg",
  "https://soundyoga.fr/wp-content/uploads/2025/08/bain-sonore-gong-sound-yoga-compiegne-pilate-1.jpg",
  "https://www.pagesjaunes.fr/media/newdam/be/c3/2f/00/00/88/73/39/02/81/6661bec32f00008873390281/6661bec32f00008873390282.jpg",
];


export default function Maison() {
	  const studioPhoto = useMemo(
    () => studioPhotos[Math.floor(Math.random() * studioPhotos.length)],
    []
  );
  return (
    <section
      id="maison"
      className="relative py-28 md:py-40 px-6 md:px-12 lg:px-20 bg-sand overflow-hidden"
      data-testid="maison-section"
    >
      <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* Left — vertical label & title */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6"
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-[1px] bg-terracotta" />
            <span className="text-xs uppercase tracking-[0.3em] text-ink/60">
              La maison
            </span>
          </div>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light text-ink leading-[0.95] tracking-tight">
            Une maison <br />
            <span className="italic-serif text-terracotta">française</span> du
            son, ancrée à Compiègne.
          </h2>
          <p className="mt-10 text-lg md:text-xl text-ink/75 font-light leading-relaxed max-w-xl">
            Yogi Market ne se limite pas à une vitrine en ligne. La boutique
            s'inscrit dans un lieu réel, un écosystème vivant et une culture du
            soin sonore portée au quotidien avec SoundYoga.
			
  <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="mt-10 max-w-xl overflow-hidden rounded-[28px] border border-ink/10 bg-cream/60 shadow-[0_24px_70px_-35px_rgba(74,51,32,0.45)]"
            data-testid="maison-studio-photo"
          >
            <img
              src={studioPhoto}
              alt="Studio SoundYoga à Compiègne"
              className="h-72 w-full object-cover md:h-80"
              loading="lazy"
            />
          </motion.div>
			
			
          </p>
        </motion.div>

        {/* Right — pillars */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ staggerChildren: 0.15, delayChildren: 0.2 }}
          className="lg:col-span-6 lg:pt-12 space-y-1"
        >
          {pillars.map((p, i) => (
            <motion.div
              key={p.k}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.8,
                delay: i * 0.15,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="group border-t border-ink/10 last:border-b py-8 md:py-10 flex gap-6 hover:bg-cream/50 transition-colors px-2 md:px-4 -mx-2 md:-mx-4 rounded-sm"
              data-testid={`maison-pillar-${i}`}
            >
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-full border border-terracotta/40 flex items-center justify-center group-hover:bg-terracotta group-hover:border-terracotta transition-all duration-500">
                  <Check
                    size={16}
                    className="text-terracotta group-hover:text-cream"
                  />
                </div>
              </div>
              <div>
                <h3 className="font-serif text-2xl md:text-3xl font-normal text-ink leading-tight mb-3">
                  {p.k}
                </h3>
                <p className="text-base text-ink/70 font-light leading-relaxed">
                  {p.v}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
